import { render, staticRenderFns } from "./matchRecord.vue?vue&type=template&id=3ffb39fe&scoped=true"
import script from "./matchRecord.vue?vue&type=script&lang=js"
export * from "./matchRecord.vue?vue&type=script&lang=js"
import style0 from "./matchRecord.vue?vue&type=style&index=0&id=3ffb39fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb39fe",
  null
  
)

export default component.exports